import { createContext, useContext, useState, useEffect } from "react";

interface ViewPreferencesContextType {
  referralView: "kanban" | "table" | undefined;
  setReferralView: (view: "kanban" | "table" | undefined) => void;
}

const ViewPreferencesContext = createContext<
  ViewPreferencesContextType | undefined
>(undefined);

const STORAGE_KEY = "referral-view-preference";

export const ViewPreferencesProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [referralView, setReferralView] = useState<
    "kanban" | "table" | undefined
  >(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem(STORAGE_KEY);
      return (stored as "kanban" | "table") || undefined;
    }
    return undefined;
  });

  useEffect(() => {
    if (referralView) {
      localStorage.setItem(STORAGE_KEY, referralView);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [referralView]);

  return (
    <ViewPreferencesContext.Provider value={{ referralView, setReferralView }}>
      {children}
    </ViewPreferencesContext.Provider>
  );
};

export const useViewPreferences = () => {
  const context = useContext(ViewPreferencesContext);
  if (context === undefined) {
    throw new Error(
      "useViewPreferences must be used within a ViewPreferencesProvider",
    );
  }
  return context;
};
